import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { groupBy, showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import individualFormReportIcon from './../../../assets/img/mm/file-lines-regular-full.svg';
import download from 'downloadjs';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import { Modal } from 'react-bootstrap';

class IndividualTrackingForms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            userInfo: getLoginDistrictInfo(),
            individualRecordsList: [],
            showApplicationModal: false,
        }
    }
    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getIndividualTrackingFormsReport = () => {
        const districtID = this.state.userInfo.districtId;
        const verificationYear = this.props.selectedSchoolYear;
        const schoolID = this.props.selectSchool;
        this.setState({ loading: true });
        let url = `/verification/reports/records/${districtID}/${verificationYear}?`;
            // Add schoolId only when a specific school is selected
            const selectedSchoolId = parseInt(schoolID, 10);
            if (selectedSchoolId > 0) {
                url += `schoolId=${selectedSchoolId}&`;
            }
            // Add access token
            url += `access_token=`;
            get(url).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
            this.setState({
                individualRecordsList: data || [],
                showApplicationModal: true,
                loading: false
            });
        })
        .catch(error => {
            this.setState({loading: false });
            console.log('Get Individual Tracking Forms response:', error);
        });
   };

   downloadPdf = (row) => {
        const verifyId = row.verifyId;
        const schoolId = this.props.selectedSchoolId;
        const districtID = this.state.userInfo.districtId;
        this.setState({ loading: true });
        const schoolParam = schoolId ? `schoolId=${schoolId}&` : '';
        get(`/verification/reports/individualTrackingForm/export/${districtID}/${verifyId}?${schoolParam}access_token=`)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.blob();
            })
            .then((blob) => {
                download(
                    blob,
                    `household-letter-${verifyId}.pdf`,
                    'application/pdf'
                );
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.setState({ loading: false });
                console.error('Error downloading PDF:', error);
            });
    };

    closeApplicationModal = () => {
        this.setState({ showApplicationModal: false });
    }

    getColumns = () => {
        return [
            {
                Header: 'Application ID',
                accessor: 'applicationId',
                style: { textAlign: 'center' }
            },
            {
                Header: 'Verify Id',
                accessor: 'verifyId',
                style: { textAlign: 'center' }
            },
            {
                Header: 'Guardian Name',
                accessor: 'guardianName'
            },
            {
                Header: 'Student Names',
                accessor: 'studentNames'
            },
            {
                Header: 'Current Eligibility',
                accessor: 'currentEligibility'
            },
            {
                Header: 'New Eligibility',
                accessor: 'newEligibility'
            },
            {
                Header: 'Completed Date',
                accessor: 'completedDate',
                Cell:({value}) => (
                   value ? (moment(value).format("YYYY-MM-DD")) : "-"
                )
            },
            {
                Header: 'Document Count',
                accessor: 'documentCount',
                style: { textAlign: 'center' }
            },
            {
                Header: 'Letter Count',
                accessor: 'letterCount',
                style: { textAlign: 'center' }
            },
            {
                Header: 'Non-Response',
                accessor: 'nonResponse',
                style: { textAlign: 'center' },
                Cell: ({ value }) => (
                    <span>{value ? 'true' : 'false'}</span>
                )
            },
            {
                Header: 'Action',
                accessor: 'action',
                Cell: row => (
                    <button className="btn btn-success btn-sm" onClick={() => this.downloadPdf(row.original)}>
                     <i className="fa fa-file-pdf-o" /> Pdf
                    </button>
                )
            }
        ];
    }
    render() {
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget" style={{ minHeight: '100px' }}>
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={individualFormReportIcon} style={{ width: '40px', height: '40px' }} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Individual Tracking Forms Report</b></span>
                                    <p>Per-household worksheets</p>
                                </div>
                            </div>
                            <div className='reportCard-widget-meeting-action' style={{
                                                                                    marginLeft: 'auto',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center'}}>
                                    <button type='button' className="btn btn-success btn-sm" style={{ margin: '0px' }}
                                    disabled={this.state.loading} 
                                    onClick={() => this.getIndividualTrackingFormsReport()}
                                    >  <i className="fa fa-folder-open-o" />{' '}Open</button>
                            </div>
                        </div>
                    </div>
                </div>
                  <Modal 
                        show={this.state.showApplicationModal}
                        onHide={this.closeApplicationModal}
                        bsSize="lg"
                        dialogClassName="verification-details-modal"
                    >
                    <Modal.Header closeButton>
                        <Modal.Title>
                           <b> Verified Applications list </b>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <ReactTable
                            data={this.state.individualRecordsList || []}
                            columns={this.getColumns()}
                            defaultPageSize={5}
                            pageSizeOptions={[5, 10, 20]}
                            showPagination={true}
                            sortable={false}
                            filterable={false}
                            showPageSizeOptions={true}
                            minRows={0}
                            className= "-striped -highlight"
                        />
                    </Modal.Body>
                 </Modal>
            </Fragment>
        );
    }
}
export default withRouter(IndividualTrackingForms);


// WEBPACK FOOTER //
// ./src/components/District/VerificationReport/individualTrackingForms.js